/*
 * File: DeliveryAddressCountrySelector.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 18 Jan 2022 12:47:18 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Form, Select } from 'antd';
import { useGetWorldsQuery } from 'redux/services/useChuckieSueService';

interface Props {
  disabled: boolean;
}

export const DeliveryAddressCountrySelector = ({ disabled }: Props): JSX.Element => {
  const { data, isLoading } = useGetWorldsQuery();
  const form = Form.useFormInstance();
  const country = form.getFieldValue('country');

  const countryNames = data?.data[0].countries.map((country) => ({ label: country.shortName, value: country.alpha2Code }));

  const handleSelect = (value: string): void => {
    form.setFieldValue('country', value);
  };

  /* ****************** Render ****************** */
  return (
    <Select defaultActiveFirstOption={true} defaultOpen={false} onSelect={handleSelect} defaultValue={'US'} value={country} loading={isLoading} showSearch disabled={disabled} options={countryNames} />
  );
};
